'use client';

import {
  Drawer,
  Portal,
  useDrawer,
  DrawerHeader,
  DrawerBody
} from 'components/pcc-components';
import { CatHeading, CatButton } from 'components/blocks-components';
import { LocationAddress } from 'services/location/types';
import { useTranslations } from 'next-intl';
import { ROOT_PORTALS } from 'constants/targets';
import { Variant, Size } from './types';
import ContactDealerMobileDrawerContent from './contact-dealer-mobile-drawer-content/contact-dealer-mobile-drawer-content';
import styles from './contact-dealer-mobile-drawer.module.scss';
import cx from 'classnames';
import {
  GA_CONTACT_DEALER,
  GA_PRIMARY_CTA
} from 'constants/analyticsConstants';

export interface ContactDealerMobileDrawerProps {
  dealerAddress: LocationAddress;
  locale: string;
  isCustomerSupportEnabled?: boolean;
  msg?: string;
  variant?: Variant;
  size?: Size;
  className?: string;
  fullWidth?: boolean;
  classname?: string;
  trackingContext?: string;
}

export default function ContactDealerMobileDrawer({
  dealerAddress,
  locale,
  isCustomerSupportEnabled = false,
  msg,
  variant,
  size,
  className = 'w-100',
  fullWidth = true,
  classname,
  trackingContext
}: Readonly<ContactDealerMobileDrawerProps>) {
  const t = useTranslations();
  const { drawerProps, openDrawer, closeDrawer, isDrawerOpen } = useDrawer();
  const btnText = msg || t('CONTACT_YOUR_DEALER');

  return (
    <div className={className}>
      <CatButton
        {...(variant && { variant })}
        size={size}
        fullWidth={fullWidth}
        onClick={openDrawer}
        className={cx({
          [styles['contact-dealer-drawer__button--text-start']]:
            variant === 'inline'
        })}
        data-track-event={GA_PRIMARY_CTA}
        data-track-attr-nltext={GA_CONTACT_DEALER}
        data-track-attr-context={trackingContext}
      >
        <span className={classname}> {btnText} </span>
      </CatButton>
      <Portal id={ROOT_PORTALS}>
        {isDrawerOpen && (
          <Drawer
            className={styles['contact-dealer-drawer__header']}
            {...drawerProps}
            data-testId="contact-dealer-mobile-drawer"
            orientation="bottom"
            onBlDrawerClose={closeDrawer}
            hasBackdrop
            verticalMaxHeight="large"
          >
            <DrawerHeader>
              <CatHeading variant="title-sm">
                {t('FOOTER_CONTACT_US')}
              </CatHeading>
            </DrawerHeader>
            <DrawerBody>
              <ContactDealerMobileDrawerContent
                dealerAddress={dealerAddress}
                locale={locale}
                isCustomerSupportEnabled={isCustomerSupportEnabled}
              />
            </DrawerBody>
          </Drawer>
        )}
      </Portal>
    </div>
  );
}
